// extracted by css-extract-rspack-plugin
export default {"arrowLink":"dhsIsD"};